export default __webpack_public_path__ + "static/media/count_down.5cb1431c.svg";